import axios from 'axios';
// import config from '../config/env'; // 引入环境配置
import { getAuthorization } from './auth'; // 引入获取权限的函数

// 创建 axios 实例
const service = axios.create({
  baseURL: "https://mp.huiyouyizhan.cn/api", // 使用环境配置的 baseURL
  timeout: 500000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求头中添加 Token
    let token = getAuthorization(); // 获取 Token
    if (token) {
      token = decodeURIComponent(token);
      config.headers['Authorization'] = token; // 设置请求头中的 Token
    }
    config.headers["clientId"] = "e5cd7e4891bf95d1d19206ce24a7b32e"
    return config;
  },
  error => {
    // 请求错误处理
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== 200) {
      // 如果业务状态码不为 200，抛出错误
      return Promise.reject(res);
    }
    return res;
  },
  error => {
    // 响应错误处理
    console.error(error.message);
    return Promise.reject(error);
  }
);

export default service;
